import PickupType from "../../enums/PickupType";
import Game from "../Game";
import GameCore from "../GameCore";
import BasePickup from "./BasePickup";
import PickupGroup from "./PickupGroup";
import CoinPickup from "./CoinPickup";
import {
  SPRITESHEET_KEYS,
  SPRITESHEET_FRAMES,
} from "../../consts/SPRITESHEETS";

export default class CamelChestPickup extends BasePickup {
  constructor(group: PickupGroup, x: number, y: number) {
    super(group, x, y, PickupType.CAMEL_CHEST, SPRITESHEET_KEYS.PICKUPS);
    this.setTexture(
      SPRITESHEET_KEYS.PICKUPS,
      SPRITESHEET_FRAMES.PICKUPS.CAMEL_CHEST
    );
    Game.Core.scene.add.existing(this);
    this.setScale(3.5 * GameCore.PixelScale);

    // Add a subtle pulsing effect
    Game.Core.scene.tweens.add({
      targets: this,
      scale: this.scale * 1.1,
      duration: 500,
      yoyo: true,
      repeat: -1,
    });
  }

  OnRecycle() {
    super.OnRecycle();
    this.setTexture(
      SPRITESHEET_KEYS.PICKUPS,
      SPRITESHEET_FRAMES.PICKUPS.CAMEL_CHEST
    );
  }

  Update() {
    super.Update();
    this.setDepth(9 + this.y - Game.Core.Player.y);
  }

  GetTaken() {
    // Play pickup sound using pooled audio (sound settings handled by facade)
    Game.Core.poolManager?.playCoinSound();

    // Get the special value from the camel that dropped this chest
    // Camel chests only come from special camels, so only use specialValue
    const specialValue = this.getData("specialValue") || 0;

    // Visual feedback - limit the number of visual coins for performance
    const displayCoinCount = Math.min(specialValue, 25);

    // Calculate if we need to create a special high-value coin
    const remainingValue = specialValue - displayCoinCount;

    // Create the limited visual coins
    for (let i = 0; i < displayCoinCount; i++) {
      const coin = Game.Core.MakePickup(
        this.x + (Math.random() - 0.5) * 70,
        this.y + (Math.random() - 0.5) * 70,
        PickupType.COIN
      );

      // Mark coins as from caravan so they're tracked correctly
      if (coin && coin.itemType === PickupType.COIN) {
        (coin as CoinPickup).isFromCaravan = true;
      }
    }

    // If we have remaining value, create one special high-value coin
    if (remainingValue > 0) {
      const specialCoin = Game.Core.MakePickup(this.x, this.y, PickupType.COIN);

      if (specialCoin && specialCoin.itemType === PickupType.COIN) {
        const coinPickup = specialCoin as CoinPickup;
        coinPickup.isFromCaravan = true;
        coinPickup.SetValue(remainingValue);
      }
    }

    // Check if there's a special gift type defined
    const specialGift = this.getData("specialGift");
    if (specialGift) {
      if (specialGift === "magnet") {
        Game.Core.MakePickup(this.x, this.y, PickupType.VACUUM);
      } else if (specialGift === "apples") {
        for (let i = 0; i < 5; i++) {
          Game.Core.MakePickup(
            this.x + (Math.random() - 0.5) * 40,
            this.y + (Math.random() - 0.5) * 40,
            PickupType.APPLE
          );
        }
      }
    }

    this.SetSeenItem(this.itemType);
    super.GetTaken();
  }
}
